import React from 'react';
import { LayoutRoute } from '../../layout/routes';
import withLoading from '../../helpers/withLoading';

const Quiz = withLoading(() => import('./'));

const route = <LayoutRoute path="/quiz/:slug([-\w]+)-:id([A-Za-z0-9\=]+)" component={Quiz} />;

export default route;
